import { createContext, useState, useEffect } from "react";

export const MyContext = createContext();

export const MyContextProvider = ({ children }) => {
  const [value, setValue] = useState("Initial value");
  const [userName, setUserName] = useState("User");
  const [usersEmail, setUsersEmail] = useState("Email");
  const [LinkSelection, setLinkSelection] = useState("");
  const [LinkSelectionWiki, setLinkSelectionWiki] = useState("");
  const [RightLinkSelection, setRightLinkSelection] = useState("Bank");
  const [InstallationLinkSelection, setInstallationLinkSelection] = useState("Installation");
  const [userId, setUserId] = useState("");
  const [MyTicket, setMyTicket] = useState("");
  const [Logins, setLogins] = useState("");
  const [Phone, setPhone] = useState("Phone Number");
  const [Profile_url, setProfile_url] = useState("https://res.cloudinary.com/dwfnhzg3y/image/upload/v1690492281/Awaice/g425y4kvrhafumpox6yj.png");
  const [TicketBoolean, setTicketBoolean] = useState("");

  const updateTicketBoolean = (newTicketBoolean) => {
    setTicketBoolean(newTicketBoolean);
  };

  const updateProfile_url = (newProfile_url) => {
    setProfile_url(newProfile_url);
  };

  const updatePhone = (newPhone) => {
    setPhone(newPhone);
  };

  const updateValue = (newValue) => {
    setValue(newValue);
  };

  const updateLogins = (newLogins) => {
    setLogins(newLogins);
  };

  const updateUserName = (newUserName) => {
    setUserName(newUserName);
  };

  const updateUsersEmail = (newUserEmail) => {
    setUsersEmail(newUserEmail);
  };

  const updateLinkSelection = (newLinkSelection) => {
    setLinkSelection(newLinkSelection);
  };

  const updateRightLinkSelection = (newRightLinkSelection) => {
    setRightLinkSelection(newRightLinkSelection);
  };

  const updateLinkSelectionWiki = (newLinkSelectionWiki) => {
    setLinkSelectionWiki(newLinkSelectionWiki);
  };

  const updateInstallationLinkSelection = (newInstallationLinkSelection) => {
    setInstallationLinkSelection(newInstallationLinkSelection);
  };

  const updateuserId = (newuserId) => {
    setUserId(newuserId);
  };

  const updateMyTicket = (newMyTicket) => {
    setMyTicket(newMyTicket);
  };

  return (
    <MyContext.Provider
      value={{
        value,
        updateValue,
        userName,
        updateUserName,
        usersEmail,
        updateUsersEmail,
        LinkSelection,
        updateLinkSelection,
        LinkSelectionWiki,
        updateLinkSelectionWiki,
        RightLinkSelection,
        updateRightLinkSelection,
        InstallationLinkSelection,
        updateInstallationLinkSelection,
        userId,
        updateuserId,
        MyTicket,
        updateMyTicket,
        Logins,
        updateLogins,
        Phone,
        updatePhone,
        Profile_url,
        updateProfile_url,
        TicketBoolean,
        updateTicketBoolean, 
      }}
    >
      {children}
    </MyContext.Provider>
  );
};
